import { useContext, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import './services.css'
import SectionImage from '../../../components/sectionImage/SectionImage';
import HeaderImage from '../../../components/headerImage/HeaderImage';
import BreadcrumbsCustomized from '../../../components/breadcrumbsCustomized/BreadcrumbsCustomized';
import Context from '../../../contexts/Context';
import { clone, orderArray } from '../../../services/serviceslocal';
import SectionOnlytext from '../../../components/sectionOnlytext/SectionOnlytext';


export default function Services() {
    const {siteContents} = useContext (Context)
    let {data} = siteContents.find(item => item.id === "services")
    
    let arrayServicesFormated = clone(orderArray(data, "position")).map((service) => {
        if(service.type === "service"){
            service.data[0].position = service.position
            return(service.data[0])
        }
        return(service)
    })

    return (
        <Box className="flex col center w100 minh100">
            <BreadcrumbsCustomized description={data[1]?.body.replace( /(<([^>]+)>)/ig, '')}/>
            {
                arrayServicesFormated.map(item => {
                    let {id, type} = item
                    if(type === "bannerService"){
                        let prevBackgroundColor = arrayServicesFormated.find(prevItem => prevItem.position === item.position - 1).backgroundColor
                        item.backgroundColor = prevBackgroundColor === "White"?"Gray":"White"
                    }
                    return(
                        type === "bannerSimple"?
                            <HeaderImage key={id}
                                animate
                                fixed
                                image={item.media}                
                                >
                                <Typography variant="h2" component="h1" className="tbold tcenter">
                                    {item.title}
                                </Typography>
                            </HeaderImage>
                        :type === "section"?
                            <SectionOnlytext key={id} data={item} /> 
                        :type === "bannerService" &&
                            <SectionImage key={id} data={item} titleLink/>
                    )
                })
            }       
        </Box>
    );
}

